import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import TextArea from "./../../../components/common/textArea/TextArea";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";
import {
  setDays,
  setTime,
  setYearMonths,
  setAdditionalInquiry,
  setImportantFactors,
  setOverrideData,
  setCustomerUuid,
  setCustomer,
} from "@src/@slice/recommendHallSlice";
import NotificationArccodion from "@src/components/booking/realtimeBooking/notification/NotificationArccodion";
import { Blank, BottomFixedModal } from "@src/shared/src";
import { closeWebview } from "@src/utils/route";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import { postRecommendHall } from "../../../api/recommend/recommend";
import { UserContext } from "@src/App";

const MonthSelectArea = () => {
  const LOOP_COUNT = 19; // 18 months + 1 (current)
  const now = dayjs();
  const [currentYear, setCurrentYear] = useState(now.get("year"));
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [currentYearCount, setCurrentYearCount] = useState(0);
  const [nextYearCount, setNextYearCount] = useState(0);
  const [yearAfterNext, setYearAfterNext] = useState(0);

  const { hallData, dispatch } = useRecommendHall();

  useEffect(() => {
    setCurrentYearCount(13 - (now.get("month") + 1));
  }, []);

  useEffect(() => {
    let yc = LOOP_COUNT - currentYearCount;
    setNextYearCount(yc > 12 ? 12 : yc);
    if (yc > 12 && currentYearCount > 0) setYearAfterNext(yc - 12);
  }, [currentYearCount]);

  return (
    <div className="month-selector-wrap">
      <p className="apply-form-content-title common-wrap">{`날짜선택(최대 4개)`}</p>
      <div key={`${now.get("year")}-month-wrap`}>
        <ul className="year-list common-wrap">
          <li
            className={`${currentYear === selectedYear ? "selected" : ""}`}
            key={`year-${currentYear}`}
            onClick={() => setSelectedYear(currentYear)}
          >
            <span>{currentYear}년</span>
          </li>
          <li
            className={`${currentYear + 1 === selectedYear ? "selected" : ""}`}
            key={`year-${currentYear + 1}`}
            onClick={() => setSelectedYear(currentYear + 1)}
          >
            <span>{currentYear + 1}년</span>
          </li>
          {yearAfterNext > 0 && (
            <li
              className={`${currentYear + 2 === selectedYear ? "selected" : ""}`}
              key={`year-${currentYear + 2}`}
              onClick={() => setSelectedYear(currentYear + 2)}
            >
              <span>{currentYear + 2}년</span>
            </li>
          )}
        </ul>
        {[currentYear, currentYear + 1, currentYear + 2].map((year) => (
          <div key={`${year}-month-wrap`}>
            <div
              className={`month-list`}
              style={{ display: currentYear === +year ? "grid" : "none" }}
            >
              {/* 이번 년도 */}
              {selectedYear === currentYear &&
                Array.from(Array(currentYearCount).keys())
                  .reverse()
                  .map((i) => (
                    <button
                      key={`select-box-list-${year}-${12 - i}`}
                      className={`btn btn-outline-gray200 btn-small ${hallData.hopeWedding.yearMonths.indexOf(`${now.get("year")}년 ${12 - i}월`) > -1 ? "selected" : ""}`}
                      onClick={() => {
                        dispatch(setYearMonths({ date: `${now.get("year")}년 ${12 - i}월` }));
                      }}
                    >
                      {12 - i}월
                    </button>
                  ))}
              {/* 다음 년도 */}
              {selectedYear === currentYear + 1 &&
                Array.from(Array(nextYearCount).keys()).map((i) => (
                  <button
                    key={`select-box-list-${year}-${12 - i}`}
                    className={`btn btn-outline-gray200 btn-small ${hallData.hopeWedding.yearMonths.indexOf(`${now.get("year") + 1}년 ${i + 1}월`) > -1 ? "selected" : ""}`}
                    onClick={() => {
                      dispatch(setYearMonths({ date: `${now.get("year") + 1}년 ${i + 1}월` }));
                    }}
                  >
                    {i + 1}월
                  </button>
                ))}
              {/* 내후년 */}
              {selectedYear === currentYear + 2 &&
                Array.from(Array(yearAfterNext).keys()).map((i) => (
                  <button
                    key={`select-box-list-${year}-${12 - i}`}
                    className={`btn btn-outline-gray200 btn-small ${hallData.hopeWedding.yearMonths.indexOf(`${now.get("year") + 2}년 ${i + 1}월`) > -1 ? "selected" : ""}`}
                    onClick={() => {
                      dispatch(setYearMonths({ date: `${now.get("year") + 2}년 ${i + 1}월` }));
                    }}
                  >
                    {i + 1}월
                  </button>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const strData = {
  days: ["토요일", "일요일", "공휴일"],
  times: ["9-11시대", "12-14시대", "15-16시대", "17시대~"],
  importantFactors: [
    "평균보다 가격이 저렴한 웨딩홀",
    "홀 분위기, 식사의 퀄리티가 높은 웨딩홀",
    "예상 보증인원 조건에 맞는 웨딩홀",
    "교통과 주차환경이 편한 웨딩홀",
  ],
};

const HopeDate = () => {
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const [validate, setValidate] = useState(true);
  const [showSelectionSheet, setShowSelectioSheet] = useState(false);
  const { hallData, dispatch, isComplete } = useRecommendHall();
  const customer = hallData.customer;
  useEffect(() => {
    if (
      hallData.hopeWedding.yearMonths.length === 0 ||
      hallData.hopeWedding.days.length === 0 ||
      hallData.hopeWedding.times.length === 0 ||
      hallData.importantFactors.length === 0
    ) {
      setValidate(false);
    } else {
      setValidate(true);
    }
  }, [hallData.hopeWedding, hallData.importantFactors]);

  useEffect(() => {
    if (isComplete) {
      window.location.href = "h2mwbell://webview/close";
    }
    if (user.me) {
      if (sessionStorage.getItem("recommendHallData")) {
        const recommendHallData = JSON.parse(sessionStorage.getItem("recommendHallData") || "{}");
        dispatch(setOverrideData({ data: recommendHallData }));
      }

      dispatch(setCustomerUuid({ uuid: user.me.uuid }));
      if (user.me.sex && customer.role === "") {
        dispatch(setCustomer({ key: "role", data: user.me.sex === 1 ? "BRIDE" : "GROOM" }));
      }
      if (user.me.customerName && customer.name === "") {
        dispatch(setCustomer({ key: "name", data: user.me.customerName }));
      }
      if (user.me.tel) {
        dispatch(setCustomer({ key: "tel", data: user.me.tel }));
      }
    }
  }, [user.me]);

  const postRecommend = () => {
    sessionStorage.removeItem("recommendHallData");
    if (isComplete) {
      alert("이미 신청된 양식입니다.");
      return;
    }

    postRecommendHall({
      ...hallData,
    })
      .then((res) => {
        navigate("/recommend/hall/complete");
      })
      .catch((err) => {
        alert("error!");
        console.log(err);
      });
  };

  return (
    <div>
      <CustomHeader goBack={() => navigate("/recommend/hall/cost")} close={closeWebview} />
      <div className="recommend-hall-hope-date page-apply-form">
        <div>
          <PageTitle title={`희망 예식 일정을 알려주세요.`} />
          <div>
            <MonthSelectArea />
            <ul
              className={`${hallData.hopeWedding.yearMonths.length > 0 ? "selected-chips-list-wrap" : ""}`}
            >
              {hallData.hopeWedding.yearMonths.map((month, idx) => (
                <li key={`month-chip-${idx}`}>
                  <span>{month}</span>
                  <button
                    className="btn btn-icon"
                    onClick={() => dispatch(setYearMonths({ date: month }))}
                  >
                    <i className="icon icon-x-gray500-18" />
                  </button>
                </li>
              ))}
            </ul>
            <div className="divider" />
            <p className="apply-form-content-title common-wrap">요일선택</p>
            <div className={`scroll-able-btn-wrap common-wrap day-list`}>
              {strData.days.map((day) => (
                <button
                  key={`month-btn-${day}`}
                  className={`btn btn-outline-gray200 btn-small ${hallData.hopeWedding.days.indexOf(day) > -1 ? "selected" : ""}`}
                  onClick={() => dispatch(setDays({ day: day }))}
                >
                  {day}
                </button>
              ))}
            </div>
            <ul
              className={`${hallData.hopeWedding.days.length > 0 ? "selected-chips-list-wrap" : ""}`}
            >
              {hallData.hopeWedding.days.map((day, idx) => (
                <li key={`day-chip-${idx}`}>
                  <span>{day}</span>
                  <button className="btn btn-icon" onClick={() => dispatch(setDays({ day: day }))}>
                    <i className="icon icon-x-gray500-18" />
                  </button>
                </li>
              ))}
            </ul>
            <div className="divider" />
            <p className="apply-form-content-title common-wrap">시간선택</p>
            <div className={`scroll-able-btn-wrap`} style={{ paddingLeft: "20px" }}>
              {strData.times.map((time, idx) => (
                <button
                  key={`time-btn-${idx}`}
                  className={`btn btn-outline-gray200 btn-small ${hallData.hopeWedding.times.indexOf(time) > -1 ? "selected" : ""}`}
                  onClick={() => dispatch(setTime({ time: time }))}
                  style={{ marginRight: "8px" }}
                >
                  {time}
                </button>
              ))}
            </div>
            <ul
              className={` ${hallData.hopeWedding.times.length > 0 ? "selected-chips-list-wrap" : ""}`}
            >
              {hallData.hopeWedding.times.map((time, idx) => (
                <li key={`time-chip-${idx}`}>
                  <span>{time}</span>
                  <button
                    className="btn btn-icon"
                    onClick={() => dispatch(setTime({ time: time }))}
                  >
                    <i className="icon icon-x-gray500-18" />
                  </button>
                </li>
              ))}
            </ul>

            <div className="divider" />
            <div style={{ padding: "16px 20px" }}>
              <h3 className="apply-form-content-title">
                웨딩홀 결정 시 가장 중요한 점은 무엇인가요?
              </h3>
              <div
                className="select select-full select-gray select-alternative-schedules"
                onClick={() => {
                  setShowSelectioSheet(true);
                }}
              >
                <span style={{ color: hallData.importantFactors === "" ? "" : "#191919" }}>
                  {hallData.importantFactors === "" ? "선택" : hallData.importantFactors}
                </span>
              </div>
            </div>
            <div className="divider" />
            <div style={{ padding: "16px 20px" }}>
              <h3 className="apply-form-content-title">추가 문의 내용을 적어주세요.</h3>
              <TextArea
                className="textarea textarea textarea-has-line"
                style={{ height: 96, marginBottom: "0" }}
                placeholder={`예) 다음 주에 투어 원해요.\n금액이 궁금해요.\n보증인원 최소로 진행하고 싶어요.`}
                defaultValue={hallData.hopeWedding.additionalInquiry}
                value={hallData.hopeWedding.additionalInquiry}
                onChange={(e) => {
                  dispatch(setAdditionalInquiry({ data: e.target.value }));
                }}
              />
            </div>
            <div className="common-wrap">
              <NotificationArccodion
                className="recommend-hall-noti"
                isOpen={true}
                title="희망 예식 일정 선택 시 참고해 주세요."
                useArccodion={false}
              >
                <p style={{ fontSize: "12px" }}>
                  예식 날짜와 시간대에 따라 보증인원 조건과 비용이 달라집니다. 아래의 보증인원 및
                  비용이 높은 순서를 참고하여 선택해보세요.
                </p>
                <ul style={{ marginTop: "12px", fontSize: "12px" }}>
                  <li>{`성수기(3~6, 9~12월) > 비수기(1, 2, 7, 8월) 예식`}</li>
                  <li>{`토요일 > 일요일 > 공휴일 예식`}</li>
                  <li>{`12~14시대 > 9~11, 15~16시대 > 17시대 예식`}</li>
                </ul>
              </NotificationArccodion>
            </div>
            <Blank height={80} />
          </div>
        </div>

        <div className="gradient-background"></div>
        <button
          disabled={!validate}
          className={`btn btn-giant btn-full btn-red500 ${!validate ? "btn-disabled" : ""}`}
          onClick={postRecommend}
        >
          웨딩홀 추천 리스트 신청하기
        </button>
      </div>
      <BottomFixedModal
        className="region-bottom-fixed-modal"
        isShow={showSelectionSheet}
        title="웨딩홀 결정 시 중요한 점은 무엇인가요?"
        isTransition={true}
        hideModal={() => {
          setShowSelectioSheet(false);
        }}
      >
        <ul>
          {strData.importantFactors.map((fact, idx) => (
            <li
              key={`important-opt-${idx}`}
              className={`selected-with-check ${fact === hallData.importantFactors ? "selected bold" : ""}`}
              style={{ display: "flex", justifyContent: "space-between" }}
              value={fact}
              onClick={() => {
                dispatch(setImportantFactors({ data: fact }));
                setShowSelectioSheet(false);
              }}
            >
              {fact}
              {fact === hallData.importantFactors && (
                <span>
                  <i className="icon icon-checkmark-brown500"></i>
                </span>
              )}
            </li>
          ))}
        </ul>
      </BottomFixedModal>
    </div>
    // </div>
  );
};

export default HopeDate;
